import React from 'react';
import { useContext } from 'react';
import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { authContext } from '../../contexts/AuthContext';
import Toggle from '../ThemeContext/Toggle';
export const Nav = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { user, logOut } = useContext(authContext);
  // console.log(user);
  return (
    <div className="bg-gray-900">
      <div className="px-4 py-5 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8">
        <div className="relative flex items-center justify-between">
          <div className="flex items-center">
            <NavLink
              to="/"
              aria-label="Company"
              title="Company"
              className="inline-flex items-center mr-8 text-green-500"
            >
              <svg
                className="w-8 text-teal-accent-400"
                viewBox="0 0 24 24"
                strokeLinejoin="round"
                strokeWidth="2"
                strokeLinecap="round"
                strokeMiterlimit="10"
                stroke="currentColor"
                fill="none"
              >
                <rect x="3" y="1" width="7" height="12" />
                <rect x="3" y="17" width="7" height="6" />
                <rect x="14" y="1" width="7" height="6" />
                <rect x="14" y="11" width="7" height="12" />
              </svg>
              <span className="ml-2 text-xl font-bold tracking-wide text-gray-100">
                CodeDoor
              </span>
            </NavLink>
            <ul className="flex items-center hidden space-x-8 lg:flex">
              <li>
                <NavLink
                  style={({ isActive }) => isActive ? { borderBottom: "2px solid green" } : undefined}
                  to="/courses"
                  aria-label="Our product"
                  title="Our product"
                  className="font-medium tracking-wide text-white hover:bg-green-500 p-1 rounded transition-colors duration-200 
                hover:text-deep-purple-accent-400"
                >
                  Courses
                </NavLink>
              </li>
              <li>
                <NavLink
                  style={({ isActive }) => isActive ? { borderBottom: "2px solid green" } : undefined}
                  to="/blog"
                  aria-label="Our product"
                  title="Our product"
                  className="font-medium tracking-wide text-white hover:bg-green-500 p-1 rounded transition-colors duration-200 
                hover:text-deep-purple-accent-400"
                >
                  Blog
                </NavLink>
              </li>
              <li>
                <NavLink
                  style={({ isActive }) => isActive ? { borderBottom: "2px solid green" } : undefined}
                  to="/about"
                  aria-label="About us"
                  title="About us"
                  className="font-medium tracking-wide text-white hover:bg-green-500 p-1 rounded transition-colors duration-200 
                hover:text-deep-purple-accent-400"
                >
                  About us
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/faq"
                  aria-label="faq"
                  title="faq"
                  className="font-medium tracking-wide text-white hover:bg-green-500 p-1 rounded transition-colors duration-200 
                hover:text-deep-purple-accent-400"
                >
                  FAQ
                </NavLink>
              </li>
              <Toggle />
            </ul>
          </div>
          <ul className="flex items-center hidden space-x-8 lg:flex">
            {user ? <>{ user.photoURL ? <img className='rounded-full' style={{ width:"2rem", height:"2rem"}} src={ user.photoURL } title={ user.displayName } alt="profile" /> : <li className='text-green-400 font-medium'>{user.displayName}</li>}<li>
              <NavLink
                onClick={logOut}
                title="Log Out"
                role="button"
                className="font-medium tracking-wide text-white hover:bg-green-500 p-1 rounded transition-colors duration-200 
                hover:text-deep-purple-accent-400"
              >
                Log Out
              </NavLink>
            </li></> : <><li>
              <NavLink
                to="/login"
                aria-label="Sign in"
                title="Sign in"
                className="font-medium tracking-wide text-white hover:bg-green-500 p-1 rounded transition-colors duration-200 hover:text-deep-purple-accent-400"
              >
                Sign in
              </NavLink>
            </li>
              <li>
                <NavLink
                  to="/register"
                  className="font-medium tracking-wide text-white hover:bg-green-500 p-1 rounded transition-colors duration-200 hover:text-deep-purple-accent-400"
                  aria-label="Sign up"
                  title="Sign up"
                >
                  Sign up
                </NavLink>
              </li></>}
          </ul>
          <div className="lg:hidden">
            <button
              aria-label="Open Menu"
              title="Open Menu"
              className="p-2 -mr-1 transition duration-200 rounded focus:outline-none focus:shadow-outline"
              onClick={() => setIsMenuOpen(true)}
            >
              <svg className="w-5 text-gray-600" viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M23,13H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,13,23,13z"
                />
                <path
                  fill="currentColor"
                  d="M23,6H1C0.4,6,0,5.6,0,5s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,6,23,6z"
                />
                <path
                  fill="currentColor"
                  d="M23,20H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,20,23,20z"
                />
              </svg>
            </button>
            {isMenuOpen && (
              <div className="absolute top-0 left-0 w-full z-50">
                <div className="p-5 bg-white border rounded shadow-sm">
                  <div className="flex items-center justify-between mb-4">
                    <div>
                      <NavLink
                        to="/"
                        aria-label="Company"
                        title="Company"
                        className="inline-flex items-center"
                      >
                        <svg
                          className="w-8 text-deep-purple-accent-400"
                          viewBox="0 0 24 24"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeMiterlimit="10"
                          stroke="currentColor"
                          fill="none"
                        >
                          <rect x="3" y="1" width="7" height="12" />
                          <rect x="3" y="17" width="7" height="6" />
                          <rect x="14" y="1" width="7" height="6" />
                          <rect x="14" y="11" width="7" height="12" />
                        </svg>
                        <span className="ml-2 text-xl font-bold tracking-wide text-gray-800 uppercase">
                          CodeDoor
                        </span>
                      </NavLink>
                    </div>
                    <div>
                      <button
                        aria-label="Close Menu"
                        title="Close Menu"
                        className="p-2 -mt-2 -mr-2 transition duration-200 rounded hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:shadow-outline"
                        onClick={() => setIsMenuOpen(false)}
                      >
                        <svg className="w-5 text-gray-600" viewBox="0 0 24 24">
                          <path
                            fill="currentColor"
                            d="M19.7,4.3c-0.4-0.4-1-0.4-1.4,0L12,10.6L5.7,4.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l6.3,6.3l-6.3,6.3 c-0.4,0.4-0.4,1,0,1.4C4.5,19.9,4.7,20,5,20s0.5-0.1,0.7-0.3l6.3-6.3l6.3,6.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.4-0.4,0.4-1,0-1.4L13.4,12l6.3-6.3C20.1,5.3,20.1,4.7,19.7,4.3z"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                  <nav>
                    <ul className="space-y-4">
                      <li>
                        <NavLink
                          to="/courses"
                          aria-label="Our product"
                          title="Our product"
                          className="font-medium tracking-wide hover:text-white hover:bg-green-500 p-1 rounded transition-colors duration-200 
                hover:text-deep-purple-accent-400"
                        >
                          Courses
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/blog"
                          aria-label="Our product"
                          title="Our product"
                          className="font-medium tracking-wide hover:text-white hover:bg-green-500 p-1 rounded transition-colors duration-200 
                hover:text-deep-purple-accent-400"
                        >
                          Blog
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/about"
                          aria-label="About us"
                          title="About us"
                          className="font-medium tracking-wide hover:text-white hover:bg-green-500 p-1 rounded transition-colors duration-200 
                hover:text-deep-purple-accent-400"
                        >
                          About us
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/faq"
                          aria-label="faq"
                          title="faq"
                          className="font-medium tracking-wide hover:text-white hover:bg-green-500 p-1 rounded transition-colors duration-200 
                hover:text-deep-purple-accent-400"
                        >
                          FAQ
                        </NavLink>
                      </li>
                      {user ? <><li>
                        <NavLink
                          onClick={logOut}
                          role="button"
                          title="Log Out"
                          className="font-medium tracking-wide hover:text-white hover:bg-green-500 p-1 rounded transition-colors duration-200 hover:text-deep-purple-accent-400"
                        >
                          Log Out
                        </NavLink>
                      </li></> : <><li>
                        <NavLink
                          to="/login"
                          aria-label="Sign in"
                          title="Sign in"
                          className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400"
                        >
                          Sign in
                        </NavLink>
                      </li>
                        <li>
                          <NavLink
                            to="/register"
                            className="inline-flex items-center justify-center w-full h-12 px-6 font-medium tracking-wide text-white transition duration-200 rounded shadow-md bg-green-400 hover:bg-deep-purple-accent-700 focus:shadow-outline focus:outline-none"
                            aria-label="Sign up"
                            title="Sign up"
                          >
                            Sign up
                          </NavLink>
                        </li></>}
                    </ul>
                    <div className='mt-3'>
                      <h6 className='mb-3'>All Categories:</h6>
                      <p className="p-2 mb-2"><NavLink className="py-3 px-1 rounded" style={({ isActive }) => isActive ? { background: "green", color: "white" } : undefined} to="/courses/1">UI/UX Design</NavLink></p>
                      <p className="p-2 mb-2"><NavLink className="py-3 px-1 rounded" style={({ isActive }) => isActive ? { background: "green", color: "white" } : undefined} to="/courses/3">Server</NavLink></p>
                      <p className="p-2 mb-2"><NavLink className="py-3 px-1 rounded" style={({ isActive }) => isActive ? { background: "green", color: "white" } : undefined} to="/courses/6">Backend</NavLink></p>
                      <p className="p-2 mb-2"><NavLink className="py-3 px-1 rounded" style={({ isActive }) => isActive ? { background: "green", color: "white" } : undefined} to="/courses/4">Database</NavLink></p>
                      <p className="p-2 mb-2"><NavLink className="py-3 px-1 rounded" style={({ isActive }) => isActive ? { background: "green", color: "white" } : undefined} to="/courses/2">Problem Solving</NavLink></p>
                      <p className="p-2 mb-2"><NavLink className="py-3 px-1 rounded" style={({ isActive }) => isActive ? { background: "green", color: "white" } : undefined} to="/courses/5">IT Support</NavLink></p>
                    </div>
                  </nav>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Nav;